/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

class FunnelAPI extends ApiClient {
  constructor() {
    super('funnels', { accountScoped: true });
  }

  async create(data) {
    const payload = data?.funnel ? data : { funnel: data };
    return axios.post(this.url, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async delete(id) {
    return axios.delete(`${this.url}/${id}`);
  }

  async update(id, data) {
    const payload = data?.funnel ? data : { funnel: data };
    return axios.patch(`${this.url}/${id}`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async reorderStages(id, stages) {
    return axios.patch(
      `${this.url}/${id}/reorder`,
      { stages },
      {
        headers: {
          'Content-Type': 'application/json',
        },
      }
    );
  }

  async getStageStats(funnelId, filterParams = {}) {
    return axios.get(`${this.url}/${funnelId}/stage_stats`, {
      params: filterParams,
    });
  }

  async getById(id) {
    return axios.get(`${this.url}/${id}`);
  }

  async exportDefinition(id) {
    return axios.get(`${this.url}/${id}/export`);
  }

  async importDefinition(data) {
    const payload = data?.funnel ? data : { funnel: data };

    return axios.post(`${this.url}/import`, payload, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
  }

  async getAll() {
    return axios.get(this.url);
  }
}

export default new FunnelAPI();
